export default __webpack_public_path__ + "static/media/carousel-2.54c43588.jpg";